// extracted by mini-css-extract-plugin
export default {"primary":"style_primary__Q-zdI","bordered":"style_bordered__hn7Y-","icon-button":"style_icon-button__y2GDJ","secondary":"style_secondary__IlmZe"};